/**
 * plugins/webfontloader.js
 *
 * webfontloader documentation: https://github.com/typekit/webfontloader
 */
export async function loadFonts() {
  const webFontLoader = await import(/* webpackChunkName: "webfontloader" */ 'webfontloader')

  webFontLoader.load({
    google: {
      api: 'https://fonts.googleapis.com/css2',
      families: [
        'Sora:wght@400;500;600;700;800&display=swap',
        'Manrope:wght@400;500;600;700;800&display=swap',
      ],
    },
  })
}
export default function () {
  loadFonts()
}
